module.exports = (__webpack_require__(15))(11);


//////////////////
// WEBPACK FOOTER
// delegated ./node_modules/react-dom/index.js from dll-reference vendor_library
// module id = 91
// module chunks = 0